import React from 'react';
import _ from 'lodash';
import { Text } from '@wix/design-system';
import { translate } from '#packages/i18n';
import constants from '#packages/constants';
import * as stateManagement from '#packages/stateManagement';

import type { EditorAPI } from '#packages/editorAPI';
import type { SerializedCompStructure } from '@wix/document-services-types';

const panelsActions = stateManagement.panels.actions;
const { GENERIC_MESSAGE_PANEL } = constants.PANELS;
const { COMP_TYPES } = constants;

const findComponentInTree = (
  structure: SerializedCompStructure,
  predicate: (comp: SerializedCompStructure) => boolean,
): boolean => {
  if (!structure.components) return false;
  return structure.components.some(
    (child) => predicate(child) || findComponentInTree(child, predicate),
  );
};

const isComponentLightBoxContainer = ({
  componentType,
}: SerializedCompStructure): boolean =>
  componentType === COMP_TYPES.POPUP_CONTAINER;

const structureHasLightBoxContainerAndForbidden = (
  structure: SerializedCompStructure,
): boolean => {
  return (
    structure.componentType !== COMP_TYPES.PAGE &&
    findComponentInTree(structure, isComponentLightBoxContainer)
  );
};

export const isValidPresetStructure = (
  structure: SerializedCompStructure,
): boolean => {
  const predicates: Array<(structure: SerializedCompStructure) => boolean> = [
    _.negate(structureHasLightBoxContainerAndForbidden),
  ];
  return predicates.every((predicate) => predicate(structure));
};

export const openInvalidPresetMessagePanel = (editorAPI: EditorAPI) => {
  const onClose = () =>
    editorAPI.store.dispatch(
      panelsActions.closePanelByNameAction(GENERIC_MESSAGE_PANEL),
    );
  editorAPI.store.dispatch(
    panelsActions.updateOrOpenPanel(
      GENERIC_MESSAGE_PANEL,
      {
        title: translate(
          'add_section_saved_sections_corrupted_error_modal_title',
        ),
        message: (
          <Text>
            {`${translate(
              'add_section_saved_sections_corrupted_error_modal_body',
            )} `}
            <a
              onClick={() =>
                editorAPI.panelManager.openHelpCenter(
                  'db865984-80bd-42c1-af05-a5d594b603f8',
                )
              }
            >
              {translate(
                'add_section_saved_sections_corrupted_error_modal_learn_more_link',
              )}
            </a>
          </Text>
        ),
        theme: 'destructive',
        confirmLabel: translate(
          'add_section_saved_sections_corrupted_error_modal_main_cta',
        ),
        close: onClose,
        onConfirm: onClose,
      },
      true,
    ),
  );
};
